import { render } from "./WhatsAppPage.vue?vue&type=template&id=f792e010&scoped=true"
import script from "./WhatsAppPage.vue?vue&type=script&lang=js"
export * from "./WhatsAppPage.vue?vue&type=script&lang=js"

import "./WhatsAppPage.vue?vue&type=style&index=0&id=f792e010&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f792e010"]])

export default __exports__